import PropTypes from 'prop-types';
import React from 'react';
import StarRating from 'contest/components/star-rating';
import SocialMediaShareButtons from 'contest/components/social-media-share-buttons';
import DesignAction from './connected/design-action';
import constants from 'contest/data/constants';
import { connectToStores } from 'fluxible-addons-react';
import ContestStore from 'contest/stores/contest-store';

class RatingAndShareDesignAction extends React.Component {
    render() {
        if (
            this.props.design.status !== constants.DESIGN_STATUS_TYPES_VISIBLE &&
            this.props.contestIsPrivate
        ) {
            return null;
        }

        const starVariations =
            this.props.activeUser && this.props.activeUser.isDesigner ? ['vibrant'] : [];

        return (
            <div className="design-actions-panel__action">
                {this.props.design.status === constants.DESIGN_STATUS_TYPES_VISIBLE && (
                    <div
                        className="design-actions-panel__action__stars"
                        data-feature-tour-step-star-rating-block
                    >
                        <StarRating
                            starVariations={starVariations}
                            isEditable={this.props.design.permission.canRate}
                            numSelectedStars={this.props.design.rating}
                            onChange={this.props.onUpdate}
                        />
                    </div>
                )}
                {!this.props.contestIsPrivate && (
                    <div className="design-actions-panel__action__share">
                        <SocialMediaShareButtons
                            shareURLs={{
                                facebook: this.props.shareURLs.facebook,
                                twitter: this.props.shareURLs.twitter,
                                pinterest: this.props.shareURLs.pinterest,
                                shortURL: this.props.shareURLs.shortURL,
                            }}
                            trackEventOptions={{
                                share_subject_type: 'entry',
                                location: 'contests ddo',
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

RatingAndShareDesignAction.propTypes = {
    design: PropTypes.object.isRequired,
    activeUser: PropTypes.object,
    onUpdate: PropTypes.func.isRequired,
    shareURLs: PropTypes.object.isRequired,
    contestIsPrivate: PropTypes.bool,
};

RatingAndShareDesignAction.defaultProps = {
    activeUser: null,
};

export default connectToStores(
    DesignAction(RatingAndShareDesignAction),
    [ContestStore],
    (ctx, props) => ({
        contestIsPrivate: ctx.getStore(ContestStore).isPrivate(),
        ...props,
    })
);



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/rating-and-share-design-action.jsx